import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import AuthenticatedImage from "./AuthenticatedImage";
import "./ImagePreview.css";

// One picture viewer for the whole app (profile pictures in the chat, tasks, profile, ...): the chat's
// image preview (centred, no frame, the green close button). ImagePreviewHost is mounted once (App);
// openImagePreview(src) shows a picture from anywhere.
const EVENT = "planit:previewImage";

export const openImagePreview = (src) => {
  if (!src) return;
  window.dispatchEvent(new CustomEvent(EVENT, { detail: { src } }));
};

export const ImagePreviewHost = () => {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    const show = (e) => setSrc((e.detail && e.detail.src) || null);
    window.addEventListener(EVENT, show);
    return () => window.removeEventListener(EVENT, show);
  }, []);
  return (
    <Modal
      visible={!!src}
      onCancel={() => setSrc(null)}
      footer={null}
      centered
      width="auto"
      bodyStyle={{ padding: 0, background: "transparent", boxShadow: "none" }}
      style={{ maxWidth: "90vw", background: "transparent", boxShadow: "none" }}
      className="chat-image-preview-modal"
      destroyOnClose
      zIndex={200100}
      closeIcon={
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center", width: 32, height: 32, borderRadius: "50%", background: "#0DDFAB", fontSize: 16, color: "#1d1d1d", fontWeight: 700, lineHeight: 1 }}>✕</span>
      }
    >
      {src && (
        <AuthenticatedImage
          src={src}
          alt="preview"
          style={{ maxWidth: "80vw", maxHeight: "75vh", objectFit: "contain", borderRadius: 8, display: "block" }}
        />
      )}
    </Modal>
  );
};

// Click handlers for a profile picture: opens it in the viewer and keeps the click from reaching what is
// behind it (a row, a card). Nothing without a picture.
export const previewOnClick = (src) => (src
  ? {
    onClick: (e) => { e.preventDefault(); e.stopPropagation(); openImagePreview(src); },
    onMouseDown: (e) => e.stopPropagation(),
  }
  : {});

// A plain profile picture (an <img>) that opens in the viewer: the zoom icon on hover, a click opens it.
// `className`/`style` shape the span (its corners, its size inside a box). Just the picture without a src.
export const PreviewZoom = ({ src, className = "", style, children }) => (src
  ? <span className={`planit-zoom planit-zoom-wrap ${className}`.trim()} style={style} {...previewOnClick(src)}>{children}</span>
  : children);
